export const hasIcons = (name) =>
  [
    "acts",
    "perpetrator_gender",
    "perpetrator_count",
    "reporter_gender",
  ].includes(name)

export const Icon = ({ name, style }) => {
  return (
    <svg class={`icon ${style ? style : ""}`}>
      <use href={`#icon-${name}`} />
    </svg>
  )
}
